
import {updateFilterUrl, parseFilterUrl} from './functions/url';
import {filterItems} from './functions/filters';

import React, { useState, useEffect } from 'react';

import FilterUI from './FilterUI';




function App(props) {
  const items = props.items;
  let filter_form = [];

  _filter_form.forEach((f) => {

    let uf = {
      title: f.filters[0].title,
      name: f.filters[0].name,
      type: "checkboxes",
      id: f.id,
      elements: []
    }

    f.filters.forEach(filter => {
      filter.elements.forEach(fe => {
        let fe_new = fe;
        fe_new.parent = f.filters[0].name;
        fe_new.id = fe.value;
        uf.elements.push(fe_new);
      })
    })

    filter_form.push(uf)
  })

  let url_data = parseFilterUrl(filter_form);
  filter_form = url_data.form;
  let current_page = url_data.page;


  let active_filters = {
    mobile_open: false,
    active_panel: 'side_filter',
    top_filter_open: false,
    side_filter_open: false,
    active_side_filter: '',
    active_date_panel: ''
  }







  return (
    <>
      <FilterUI
        filter_form={filter_form}
        items={items}
        current_page={current_page}
        active_filters={active_filters}

        />
    </>
  );
}

export default App;
